import type {
  CreateGuestProposalRequest,
  GuestProposalReceipt,
  GuestProposalReceiptResponse,
  GuestProposalResource,
  GuestProposalResourceListResponse,
} from '@mds/shared/types/proposal';

import { api } from '@/lib/api';

/** The public proposal endpoints — see `backend/docs/proposals.md`. */

/**
 * Spaces configured for proposal review rather than direct requests, with
 * their rate, capacity and weekly hours.
 */
export const listProposalResources = (): Promise<GuestProposalResource[]> =>
  api.get<GuestProposalResourceListResponse>('proposal-resources').then((r) => r.data);

/**
 * Submits a proposal. It reserves nothing, and there is no status page: every
 * update reaches the guest by email.
 *
 * `requestId` makes a retry idempotent. Reuse it only to resend the identical
 * body — a changed body under the same id is `PROPOSAL_REQUEST_ID_REUSED`.
 */
export const submitProposal = (body: CreateGuestProposalRequest): Promise<GuestProposalReceipt> =>
  api.post<GuestProposalReceiptResponse>('proposals', body).then((r) => r.data);
